export const GoogleMapApiConfig = 'AIzaSyBTF7xDdZw9q9zHF0CwDfNS9da4zUD1sV0';